














import { Vue, Component } from 'vue-property-decorator';
import ConfiguracionComandosSMS from '@/pantallas/TorreControl/ConfiguracionComandosSMS/ConfiguracionComandosSMS.vue';

@Component({
  components: { ConfiguracionComandoComponent: ConfiguracionComandosSMS },
})
export default class ConfiguracionComandosSMSPantalla extends Vue {}
